import { User, Case, Settlement } from '../types';

export const users: User[] = [
  {
    id: '1',
    name: 'John Smith',
    email: 'john.smith@lawfirm.com',
    role: 'lawyer',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?fit=crop&w=100&h=100'
  },
  {
    id: '2',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@lawfirm.com',
    role: 'paralegal',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?fit=crop&w=100&h=100'
  },
  {
    id: '3',
    name: 'Michael Chen',
    email: 'michael.chen@lawfirm.com',
    role: 'partner',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?fit=crop&w=100&h=100'
  },
  {
    id: '4',
    name: 'Robert Johnson',
    email: 'robert.johnson@example.com',
    role: 'client',
    avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?fit=crop&w=100&h=100'
  },
  {
    id: '5',
    name: 'Emily Thompson',
    email: 'emily.thompson@example.com',
    role: 'client',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?fit=crop&w=100&h=100'
  },
  {
    id: '6',
    name: 'David Martinez',
    email: 'david.martinez@example.com',
    role: 'client',
    avatar: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?fit=crop&w=100&h=100'
  },
  {
    id: '7',
    name: 'Lisa Wang',
    email: 'lisa.wang@techstart.com',
    role: 'client',
    avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?fit=crop&w=100&h=100'
  },
  {
    id: '8',
    name: 'James Davidson',
    email: 'james.davidson@example.com',
    role: 'client',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?fit=crop&w=100&h=100'
  }
];

export const cases: Case[] = [
  {
    id: '1',
    title: 'Johnson v. Smith Construction',
    caseNumber: 'PI-2024-001',
    clientId: '4', // Robert Johnson
    assignedLawyerId: '1',
    status: 'active',
    practiceArea: 'Personal Injury',
    description: 'Workplace injury case involving construction site accident',
    currentStageId: 'discovery-phase',
    documents: [
      {
        id: 'd1',
        title: 'Initial Complaint',
        type: 'legal',
        uploadDate: new Date().toISOString(),
        uploadedBy: '1',
        url: '#'
      }
    ],
    tasks: [], // Tasks will be populated by the store
    timeline: [
      {
        id: 'tl1',
        date: getFutureDate(-15), // Set to 15 days ago
        description: 'Case filed with court',
        type: 'document-filed',
        addedBy: '1'
      },
      {
        id: 'tl2',
        date: getFutureDate(-12), // Set to 12 days ago
        description: 'Entered Discovery Phase',
        type: 'stage-change',
        addedBy: '1',
        stageId: 'discovery-phase'
      }
    ],
    keyDates: [
      {
        type: 'intake',
        date: getFutureDate(-15),
        description: 'Case intake completed'
      },
      {
        type: 'filing',
        date: getFutureDate(7),
        description: 'Initial complaint filed'
      },
      {
        type: 'hearing',
        date: getFutureDate(45),
        description: 'Initial hearing scheduled'
      },
      {
        type: 'deadline',
        date: getFutureDate(30),
        description: 'Discovery documents due'
      }
    ],
    createdAt: getFutureDate(-15)
  },
  {
    id: '2',
    title: 'Thompson Family Trust',
    caseNumber: 'EP-2024-002',
    clientId: '5', // Emily Thompson
    assignedLawyerId: '3',
    status: 'active',
    practiceArea: 'Estate Planning',
    description: 'Complex estate planning case involving multiple trusts and international assets',
    currentStageId: 'documents-received',
    documents: [],
    tasks: [], // Tasks will be populated by the store
    timeline: [
      {
        id: 'tl1',
        date: getFutureDate(-10),
        description: 'Initial client consultation',
        type: 'client-meeting',
        addedBy: '3'
      }
    ],
    keyDates: [
      {
        type: 'intake',
        date: getFutureDate(-10),
        description: 'Initial consultation completed'
      }
    ],
    createdAt: getFutureDate(-10)
  },
  {
    id: '3',
    title: 'Martinez v. City Hospital',
    caseNumber: 'PI-2024-003',
    clientId: '6', // David Martinez
    assignedLawyerId: '1',
    status: 'active',
    practiceArea: 'Personal Injury',
    description: 'Medical malpractice case involving surgical complications',
    currentStageId: 'investigation',
    documents: [],
    tasks: [], // Tasks will be populated by the store
    timeline: [
      {
        id: 'tl1',
        date: getFutureDate(-5),
        description: 'Case opened and investigation started',
        type: 'note',
        addedBy: '1'
      }
    ],
    keyDates: [
      {
        type: 'intake',
        date: getFutureDate(-5),
        description: 'Case intake completed'
      },
      {
        type: 'deadline',
        date: getFutureDate(180),
        description: 'Statute of limitations deadline'
      }
    ],
    createdAt: getFutureDate(-5)
  },
  {
    id: '4',
    title: 'TechStart IP Dispute',
    caseNumber: 'IP-2024-004',
    clientId: '7', // Lisa Wang
    assignedLawyerId: '3',
    status: 'active',
    practiceArea: 'Intellectual Property',
    description: 'Patent infringement case in the software industry',
    currentStageId: 'mediation-scheduled',
    documents: [],
    tasks: [], // Tasks will be populated by the store
    timeline: [
      {
        id: 'tl1',
        date: getFutureDate(-30),
        description: 'Mediation date set',
        type: 'court-date',
        addedBy: '3'
      }
    ],
    keyDates: [
      {
        type: 'hearing',
        date: getFutureDate(15),
        description: 'Mediation session'
      }
    ],
    createdAt: getFutureDate(-30)
  },
  {
    id: '5',
    title: 'Davidson Divorce Settlement',
    caseNumber: 'FL-2024-005',
    clientId: '8', // James Davidson
    assignedLawyerId: '2',
    status: 'active',
    practiceArea: 'Family Law',
    description: 'High-asset divorce case with custody considerations',
    currentStageId: 'settlement-draft',
    documents: [],
    tasks: [], // Tasks will be populated by the store
    timeline: [
      {
        id: 'tl1',
        date: getFutureDate(-15),
        description: 'Settlement negotiations initiated',
        type: 'note',
        addedBy: '2'
      }
    ],
    keyDates: [
      {
        type: 'deadline',
        date: getFutureDate(10),
        description: 'Settlement proposal deadline'
      }
    ],
    createdAt: getFutureDate(-45)
  }
];

export const settlements: Settlement[] = [
  {
    id: '1',
    caseId: '1',
    amount: 250000,
    date: getFutureDate(30),
    status: 'proposed',
    terms: 'Full settlement with non-disclosure agreement'
  },
  {
    id: '2',
    caseId: '5',
    amount: 1500000,
    date: getFutureDate(10),
    status: 'proposed',
    terms: 'Property division and alimony agreement'
  }
];

// Helper function to get a future date
function getFutureDate(daysFromNow: number) {
  const date = new Date();
  date.setDate(date.getDate() + daysFromNow);
  return date.toISOString();
}